// JsFromRoutes CacheKey 1fc6cda6feee8b27cc3f004a901968a8
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  update: /* #__PURE__ */ definePathHelper('post', '/admin/tasks/tasks/:task_id/update'),
  retry: /* #__PURE__ */ definePathHelper('post', '/admin/tasks/tasks/:task_id/retry'),
  updateTaskStatus: /* #__PURE__ */ definePathHelper('post', '/admin/tasks/tasks/:task_id/update_task_status'),
  dangerousForceReperformTask: /* #__PURE__ */ definePathHelper('post', '/admin/tasks/tasks/:task_id/dangerous_force_reperform_task'),
  show: /* #__PURE__ */ definePathHelper('get', '/admin/tasks/tasks/:id'),
  spa: /* #__PURE__ */ definePathHelper('get', '/admin/tasks/v2'),
  adminTasks: /* #__PURE__ */ definePathHelper('get', '/admin/tasks/v2/*path'),
}
